export enum MessageType {
  PaymentInformation = 'PaymentInformation',
}

export interface Message {
  type: MessageType;
  data: any;
}
